import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
export class CoreService {
    constructor(http, router, route) {
        this.http = http;
        this.router = router;
        this.route = route;
        // tslint:disable-next-line: variable-name
        this.apiUrl = 'http://';
        this.signedIn = false;
        this.isAdmin = false;
    }
    getJSON(url) {
        return this.http.get(url);
    }
    getApiUrl() {
        return this.apiUrl;
    }
    // sampleRequest(): Observable<any[]> {
    //   return this.http.get<any[]>(this.apiUrl).pipe(
    //     tap((data) => data),
    //     catchError(this.handleError)
    //   );
    // }
    getIsAdmin() {
        return this.isAdmin;
    }
    isSignedIn() {
        return this.signedIn;
    }
    signOut() {
        // For demo only
        this.signedIn = false;
        this.isAdmin = false;
    }
    signIn() {
        // For demo only
        this.signedIn = true;
        this.isAdmin = false;
    }
    signInAdmin() {
        // For demo only
        this.signedIn = true;
        this.isAdmin = true;
    }
    getPredefinedBillsMessages() {
        return [
            { id: 1, name: 'Factura pendiente' },
            { id: 2, name: 'Factura bla bla' },
        ];
    }
    getItemDetails(id, obj) {
        for (const item of obj) {
            if (item.id === id) {
                return item;
            }
        }
        return [];
    }
    getItemSpecificDetail(id, key, obj) {
        for (const item of obj) {
            if (item.id === id) {
                return item[key];
            }
        }
        return '';
    }
}
CoreService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CoreService_Factory() { return new CoreService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i2.ActivatedRoute)); }, token: CoreService, providedIn: "root" });
